export function toggleListValue(setList, value) {
  setList((previousList) => {
    if (previousList.includes(value)) {
      return previousList.filter((c) => c !== value);
    }
    return [...previousList, value];
  });
}
